import React from "react";
//import { BrowserRouter as Router } from "react-router-dom";
import AppRoutes from "./routes/Routes";
import { AuthProvider } from "./services/auth/AuthContext";
function App() {
  return (
  <AuthProvider>
    <AppRoutes />
  </AuthProvider>
);
}

export default App;
